import { Table } from 'antd';
import { getTableColumns } from './constants';
import { isMobile } from '../../../../../../services/clientService';

export const SoldPropertiesTable = ({
  isLoading,
  data,
  isMultiFamilySelected,
  isVacantSelected,
}) => {
  const tableScroll = {
    scrollToFirstRowOnChange: true,
    x: isMobile() ? true : '',
  };

  return (
    <Table
      rowKey="address"
      loading={isLoading}
      columns={getTableColumns({ isMultiFamilySelected, isVacantSelected })}
      dataSource={data?.soldProperties || []}
      scroll={tableScroll}
    />
  );
};
